import React, { useState, useEffect } from "react";
// import { Breadcrumb, Button, Card, CardBody, CardHeader, Col, Container, Nav, Row, Stack } from "react-bootstrap";
import { Button, Breadcrumb, Card, CardBody, CardHeader, Col, Container, Form, Row, Stack, 
  Table, Spinner, FormControl, FormSelect, Badge, Popover, OverlayTrigger } from "react-bootstrap";
  import Select from 'react-select';
import Confirm from "../Confirm";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import FilesCreate from "../File/FilesCreate";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import RelatedListFiles from "../File/RelatedListFiles";
// import RelatedListTask from "../task/RelatedListTask";
// import TaskEdit from "../task/TaskEdit";
import * as constants from "../../constants/CONSTANT";
import Image from "react-bootstrap/Image";
import moment from "moment";
import { disableCursor } from "@fullcalendar/core/internal";
// import Permissionhelper from "../common/Permissionhelper";
import { ROUTES } from "../../constants/WebRouting";
import trasportApi from "../../api/trasportApi";
import { formatDate } from "../../utils/helper";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import RelatedListPurchaseOrder from "./RelatedListPurchaseOrder";
import Main from "../layout/Main";

const PurchaseOrderView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [purchaseOrder, setPurchaseOrder] = useState(location.state ? location.state : {});

  const [modalShow, setModalShow] = useState(false);
  const [modalShowFile, setModalShowFile] = useState(false);
  const [modalShowTask, setModalShowTask] = useState(false);

  const [relatedListFiles, setRelatedListFiles] = useState(true);
  const [relatedListTask, setRelatedListTask] = useState(false);
  const [purchaseLineItem, setPurchaseLineItem] = useState(false);

  const [refreshFileList, setRefreshFileList] = useState();
  const [refreshTaskList, setRefreshTaskList] = useState();
  const fetchData = () => {
    if (!purchaseOrder.id && location.hasOwnProperty("pathname")) {
      purchaseOrder.id = location.pathname.split("/")[2];
    }
    async function init() {
      let result = await trasportApi.fetchPurchaseOrderById(purchaseOrder.id);
      console.log("fetchPurchaseOrderById == ",result)
      if (result) {
        setPurchaseOrder(result);
      } else {
        setPurchaseOrder({});
      }

    }
    init();
  };

  useEffect(() => {
    fetchData();
  }, [])
  const submitTasks = () => {
    setModalShowTask(false);
    setRefreshTaskList(Date.now());
  };

  const handleSelect = (key) => {
    console.log("in handleSelect == ",key)
    if (key === "files") {
      setRelatedListFiles(true);
      setRelatedListTask(false);
      setPurchaseLineItem(false);
    } else if (key === "tasks") {
      setRelatedListFiles(false);
      setRelatedListTask(true);
      setPurchaseLineItem(false);
    }else if (key === "purchase_item") {
      setRelatedListFiles(false);
      setRelatedListTask(false);
      setPurchaseLineItem(true);
    }
  };

  const submitFiles = () => {
    setModalShowFile(false);
    setRefreshFileList(Date.now());
    setModalShowTask(false);
  };

  const deleteRecord = async () => {
    const result = await trasportApi.deletePurchaseOrderById(purchaseOrder.id);
    if (result.success) navigate(ROUTES.PURCHASE_ORDER.LIST);
  };

  const editRecord = () => {
    navigate(`${ROUTES.PURCHASE_ORDER.LIST}/${purchaseOrder.id}/e`, { state: purchaseOrder });
  };



   
  return (
    <>
    <Main>
     
      {purchaseOrder && (
        <Container className="pb-5" >
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteRecord={deleteRecord}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="Vehicle"
            />
          )}
          <Row className="">
            <Col md={12} className="">
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>Home</Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.PURCHASE_ORDER.LIST)} >Purchase Orders</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col md={12}>
              <Row className="">
                 
                <Col lg={12}>
                  <Card className="shadow">
                    <CardHeader className="card-header" style={{background : "#1A293B" , color : "white"}}>
                      <Row className="w-100"  >
                        <Col lg={6} className="" >
                          <div className="d-flex align-items-center h-100 gap-3 data-table" >
                            <h5 className="m-0">
                              Purchase Order
                            </h5>
                            <h5 className="m-0">
                              {purchaseOrder.purchase_order_no || ""}
                            </h5>
                          </div>
                        </Col>
                        <Col lg={6} className="p-0" >

                          <Stack direction="horizontal" className="float-end" gap={3}>
                            <Button
                              size="sm"
                              className="btn-edit"
                              onClick={() => editRecord(true)}
                            >
                              <i className="fa-regular fa-pen-to-square"></i>
                            </Button>

                            {/* {Permissionhelper.checkPermission(
                              constants.SUPER_ADMIN
                            ) && ( */}
                                <Button
                                  size="sm"
                                  className=""
                                  variant="danger"
                                  onClick={() => setModalShow(true)}
                                >
                                  {/* <i className="fa fa-trash-o"></i> */}
                                  Delete
                                </Button>
                              {/* )} */}
                          </Stack>

                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody className="">
                      <Row className="view-form">
                        <Col lg={6}>
                          <label>Purchase Date</label>
                          <span>{formatDate(purchaseOrder?.purchase_date)}</span>
                        </Col>
                        {/* <Col lg={6}>
                          <label>Pi No</label>
                          <span>{purchaseOrder?.pi_no || ""}</span>
                        </Col> */}
                        <Col lg={6}>
                          <label>Vendor Name</label>
                          <span>{purchaseOrder?.contact_name || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Financial Year</label>
                          <span>{purchaseOrder?.financial_name || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Vendor Address</label>
                          <span>{purchaseOrder?.street || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Vendor Mobile Number</label>
                          <span>{purchaseOrder?.phone || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Vendor Email</label>
                          <span>{purchaseOrder?.email || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Origin</label>
                          <span>{purchaseOrder?.origin || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Purchase Price</label>
                          <span>{purchaseOrder?.purchase_price || ""}</span>
                        </Col>
                        {/* <Col lg={6}>
                          <label>Branch Price</label>
                          <span>{purchaseOrder?.branch_price || ""}</span>
                        </Col> */}
                        <Col lg={6}>
                          <label>Shipment</label>
                          <span>{formatDate(purchaseOrder?.shipment)}</span>
                        </Col>
                        {/* <Col lg={6}>
                          <label>Inco Term</label>
                          <span>{purchaseOrder?.inco_term || ""}</span>
                        </Col> */}
                        <Col lg={6}>
                          <label>Invoice Number</label>
                          <span>{purchaseOrder?.invoice_no || ""}</span>
                        </Col>
                        {/* <Col lg={6}>
                          <label>Fob</label>
                          <span>{purchaseOrder?.fob || ""}</span>
                        </Col> */}
                        <Col lg={6}>
                          <label>Freight</label>
                          <span>{purchaseOrder?.freight || ""}</span>
                        </Col>
                        {/* <Col lg={6}>
                          <label>Ectn</label>
                          <span>{purchaseOrder?.ectn || ""}</span>
                        </Col> */}
                        <Col lg={6}>
                          <label>Insurance</label>
                          <span>{purchaseOrder?.insurance || ""}</span>
                        </Col>
                        {/* <Col lg={6}>
                          <label>Invoice Amount</label>
                          <span>{purchaseOrder?.invoice_amount || ""}</span>
                        </Col> */}
                        <Col lg={6}>
                          <label>Advance Payment</label>
                          <span>{purchaseOrder?.advance_payment || ""}</span>
                        </Col>
                        {/* <Col lg={6}>
                          <label>Advance Percentage</label>
                          <span>{purchaseOrder?.advance_percentage || ""}</span>
                        </Col> */}
                        {/* <Col lg={6}>
                          <label>Full Payment</label>
                          <span>{purchaseOrder?.full_payment || ""}</span>
                        </Col> */}
                        {/* <Col lg={6}>
                          <label>Balance</label>
                          <span>{purchaseOrder?.balance || ""}</span>
                        </Col> */}
                        <Col lg={6}>
                          <label>Payment Status</label>
                          <span>{purchaseOrder?.payment_status || ""}</span>
                        </Col>
                        {/* <Col lg={6}>
                          <label>Pi Amount</label>
                          <span>{purchaseOrder?.pi_amount || ""}</span>
                        </Col> */}
                        {/* <Col lg={6}>
                          <label>Branch Sc</label>
                          <span>{purchaseOrder?.branch_sc || ""}</span>
                        </Col>
                        <Col lg={6}>
                          <label>Branch Inv</label>
                          <span>{purchaseOrder?.branch_inv || ""}</span>
                        </Col> */}
                        {/* <Col lg={6}>
                          <label>Payment Term</label>
                          <span>{purchaseOrder?.payment_term || ""}</span>
                        </Col> */}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>

            <Col md={12} >
              <Card bg="light" text="light" className="mb-2 mt-4 shadow">
                <Card.Header className="d-flex justify-content-between">
                  <Tabs
                    defaultActiveKey="files"
                    id="uncontrolled-tab-example"
                    onSelect={(key) => handleSelect(key)}
                  >
                    {/* <Tab eventKey="patienttests" title="Medical Tests"></Tab> */}
                     <Tab eventKey="files" title="Files"></Tab>
                    {/*<Tab eventKey="tasks" title="Tasks"></Tab> */}
                    <Tab eventKey="purchase_item" title="Purchase Line Item"></Tab>
                  </Tabs>

                  {/* uncomment this buttton and modal by shahir hussain */}
                  {relatedListFiles && (
                    <Button
                      size="sm"
                      className="float-right btn-custom"
                      onClick={() => setModalShowFile(true)}
                    >
                      New File
                    </Button>
                  )}
                  {modalShowFile && (
                    <FilesCreate
                      show={modalShowFile}
                      onHide={() => setModalShowFile(false)}
                      parent={purchaseOrder}
                      // table="medicaltest"
                      table="Contact" //Change by shahir hussain
                      submitFiles={submitFiles}
                    />
                  )}

                  {/* {relatedListTask && (
                    <Button
                      size="sm"
                      className="float-right btn-custom"
                      onClick={() => setModalShowTask(true)}
                    >
                      New Task
                    </Button>
                  )}
                  {modalShowTask && (
                    <TaskEdit
                      show={modalShowTask}
                      onHide={() => setModalShowTask(false)}
                      parentid={purchaseOrder.id}
                      table="account"
                      submitTasks={submitTasks}
                    />
                  )} */}
                </Card.Header>
                <Card.Body>

                  {/* uncomment this modal by shahir hussain for show related file data */}
                  {relatedListFiles && (
                    <RelatedListFiles
                      refreshFileList={refreshFileList}
                      parent={purchaseOrder}
                      submitFiles={submitFiles}
                      table="Contact"
                    />
                  )}
                  {/*
                  {relatedListTask ? (
                    <RelatedListTask
                      refreshTaskList={refreshTaskList}
                      parent={purchaseOrder}
                    />
                  ) : (
                    ""
                  )} */}
                  {purchaseLineItem ? (
                    <RelatedListPurchaseOrder
                      // refreshTaskList={refreshTaskList}
                      parent={purchaseOrder}
                    />
                  ) : (
                    ""
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
      </Main>
    </>
  );
};
export default PurchaseOrderView;
